import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import moment, { Moment } from "moment";
import { useCallback, useMemo, useState } from "react";
import { TModalEditData } from ".";
import { DatePicker } from "@mui/x-date-pickers";
import { TListaParcelas } from "../../screens/Comercial/components/MIPedidos/DialogCriarPedidoVenda";

export default function EditDataParcelaDialog({
    open,
    defaultValue,
    listaParcelas,
    blockEdit = false,
    maxParcelas,
    handleClose,
    handleDataChange
}: EditDataParcelaDialogProps) {

    const [dataSelecionada, setDataSelecionada] = useState<Moment>(moment(defaultValue.date, 'DD/MM/YYYY'))

    // Valores importantes
    const index = useMemo(() => defaultValue.index, [defaultValue])
    const minDate = useMemo(() => {
        if (index <= 0) {
            return moment();
        }
        const dataAnterior = moment(listaParcelas[index - 1].vencimento, "DD/MM/YYYY");
        return dataAnterior.add(1, "days");

    }, [index, listaParcelas]);


    const maxDate = useMemo(() => {
        if (index === listaParcelas.length - 1) {
            return moment().add(maxParcelas, "months").endOf("month");
        }
        return moment().add(maxParcelas, "months").endOf("month").subtract(listaParcelas.length - 1 - index, "days");

    }, [index, listaParcelas, maxParcelas]);

    const isDataValida = useMemo(() => {
        if (!dataSelecionada || !dataSelecionada.isValid()) {
            return false;
        }
        const minDateClone = minDate.clone();
        const maxDateClone = maxDate.clone();
        return dataSelecionada.isSameOrAfter(minDateClone, 'day') && 
               dataSelecionada.isSameOrBefore(maxDateClone, 'day');
    }, [dataSelecionada, minDate, maxDate]);

    //Funções Manipuladoras
    const handleSubmit = useCallback(() => {
        handleDataChange(index, dataSelecionada)
        handleClose()
    }, [dataSelecionada, handleDataChange, index, handleClose])
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Alterar vencimento ({defaultValue.index + 1}ª parcela)
            </DialogTitle>
            <DialogContent>
                <Box
                    py={2}
                >
                    <DatePicker
                        minDate={minDate}
                        maxDate={maxDate}
                        sx={{ width: '100%' }}
                        label="Vencimento"
                        value={dataSelecionada}
                        onChange={(data) => setDataSelecionada(data as Moment)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={blockEdit || !isDataValida}
                >
                    Editar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface EditDataParcelaDialogProps {
    open: boolean,
    defaultValue: TModalEditData,
    listaParcelas: Array<TListaParcelas>,
    handleClose: () => void,
    handleDataChange: (index: number, data: Moment) => void
    blockEdit?: boolean
    maxParcelas: number
}